import {
  defaultCard,
  defaultCardWithText,
} from "src/components/shared/Cards/sharedStyles";
import styled, { css } from "styled-components";

export const BoardCardWrapper = styled.button<{ isActive: boolean }>`
  ${defaultCard}
  ${defaultCardWithText}

  ${({ theme, isActive }) => css`
    background-color: ${isActive
      ? theme.colors.cards.fills.active
      : theme.colors.cards.fills.inactive};
    border: ${theme.border.thin} solid
      ${isActive
        ? theme.colors.cards.borders.primary
        : theme.colors.cards.borders.secondary};
  `}



  cursor: pointer;
`;
